import getCalendarFoldersOperation from 'owa-service/lib/operation/getCalendarFoldersOperation';
import GetCalendarFoldersResponse from 'owa-service/lib/contract/GetCalendarFoldersResponse';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

/**
 * Makes the call to the server to get all calendar folders and groups configuration
 * @returns promise of GetCalendarFoldersResponse type
 */
export default function getCalendarFoldersService(): Promise<GetCalendarFoldersResponse> {
    return getCalendarFoldersOperation({
        Header: getJsonRequestHeader(),
    });
}
